'use client'

import { authSelector } from "@/components/features/selectors/authSelector";
import { useRouter } from "next/navigation";
import { useSelector } from "react-redux";
import { useEffect } from "react";

const ProtectedRoute = ({ children }) => {
  const router = useRouter();
  const { token } = useSelector(authSelector);
  console.log("token", token)
  useEffect(() => {
    if (!token) {
      router.replace("/login");
    }
  }, [token, router]);

  // jab token nahi ho tab kuch render hi mat karo
  if (!token) return null;

  return children;
};

export default ProtectedRoute;
